<script setup lang="ts">
import type BaseMediaGallery from "~/components/base/display/BaseMediaGallery.vue";

type Props = {
  slider?: Pick<
    InstanceType<typeof BaseMediaGallery>,
    "canSlidePrev" | "canSlideNext" | "prevPage" | "nextPage"
  > | null;
};

defineProps<Props>();

type Slots = {
  action?(): HTMLElement;
};

defineSlots<Slots>();
</script>

<template>
  <div class="hidden md:flex items-center space-x-2">
    <slot name="action" />
    <BaseButton
      data-cy="slider-button-bar-previous-button"
      class="slider-button-bar__button"
      color-scheme="secondary"
      :disabled="!slider?.canSlidePrev"
      @click="slider?.prevPage()"
    >
      <span class="sr-only">{{ $t("paginator.previous") }}</span>
      <BaseIcon
        name="chevronLeft"
        :size="24"
      />
    </BaseButton>
    <BaseButton
      data-cy="slider-button-bar-next-button"
      class="slider-button-bar__button"
      color-scheme="secondary"
      :disabled="!slider?.canSlideNext"
      @click="slider?.nextPage()"
    >
      <span class="sr-only">{{ $t("paginator.next") }}</span>
      <BaseIcon
        name="chevronRight"
        :size="24"
      />
    </BaseButton>
  </div>
</template>

<style lang="postcss" scoped>
.slider-button-bar {
  &__button {
    @apply w-10 h-10 p-1.5;
    @apply bg-platform-bg-2 border-none text-platform-text-1;
  }
}
</style>
